import { css } from "@emotion/css";

import { Icon, IconProps } from "./Icon/Icon";

interface Props extends IconProps {
  tint?: "green" | "tofino" | "blue" | "purple" | "red" | "orange";
}

export const StyledIcon = (props: Props) => {
  const { tint = "tofino", ...iconProps } = props;

  return (
    <div
      className={styles.styledIcon}
      style={{
        backgroundColor: `var(--background-accent-${tint}-weak)`,
      }}
    >
      <Icon
        size="space-4"
        color={`icon-accent-${tint}-strong`}
        {...iconProps}
      />
    </div>
  );
};

const styles = {
  styledIcon: css({
    backgroundColor: "var(--background-accent-neutral-weak)",
    padding: "var(--space-2)",
    borderRadius: "var(--border-radius-2)",
    display: "flex",
    alignContent: "center",
    justifyContent: "center",
  }),
};
